import { NDS_CALC } from '../global-constants.js';
import { loadScript } from '../utils/loadScript.js';

const activateDealStarter = (vehicle) => {
	const {
		finalPrice,
		inventoryType,
		msrp,
		uuid
	} = vehicle;
	window.caiEventBus.emit('wallet:setInventory', {
		inventory: {
			id: uuid,
			pricingDetail: {
				salePrice: finalPrice,
				msrp
			},
			type: inventoryType
		}
	});
};

export const insertDealStarter = async (walletScriptHost, config, vehicle) => {
	const { walletTheme } = config;
	const secondaryContent = document.querySelector('#secondary-content') ||
	                         document.querySelector('[data-region="secondary-content"]');
	if (!secondaryContent) return;
	const ndsCalc = document.createElement(NDS_CALC);
	if (walletTheme) {
		ndsCalc.setAttribute('theme', walletTheme);
	}
	secondaryContent.appendChild(ndsCalc);
	await loadScript(`${walletScriptHost}/${NDS_CALC}.js`, { id: 'nds-calc-bundle' });
	if (vehicle) {
		activateDealStarter(vehicle);
	}
}
